import React from "react";
import './Work.css';

export default function () {
    return (

        <>
            <section className="sec-work pb-4">  {/* section work started */}

                <div className="container">
                    <h2 className="text-center text-white fw-bold pt-md-5">CRYSTAL WORK</h2>

                    <p className="text-center text-white pt-4">Mauris mattis vitae libero eget iaculis. Donec et augue quis quam porttitor consectetur ut nec <br />sem. Integer sagittis viverra quam quis ultricies. Aenean risus nisl, consequat at nunc id, tincidunt <br />tristique mauris.</p>

                    <div className="row pt-4">

                        <div className="col-12 col-md-4">
                            <img src="/images/work-img-1.jpg" alt="" className="img-fluid" />
                        </div>
                        <div className="col-12 col-md-4">
                            <img src="/images/work-img-2.jpg" alt="" className="img-fluid" />
                        </div>
                        <div className="col-12 col-md-4">
                            <img src="/images/work-img-3.jpg" alt="" className="img-fluid" />
                        </div>

                    </div>

                    <div className="row">

                        <div className="col-12 col-md-4 pt-3">
                            <img src="/images/work-img-4.jpg" alt="" className="img-fluid" />
                        </div>
                        <div className="col-12 col-md-4  pt-3">
                            <img src="/images/work-img-5.jpg" alt="" className="img-fluid" />
                        </div>
                        <div className="col-12 col-md-4  pt-3">
                            <img src="/images/work-img-2.jpg" alt="" className="img-fluid" />
                        </div>

                    </div>

                </div>

            </section>  {/* section work End */}
        </>

    )
}